import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "about-us",
  "use": "about-us-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"about-us\"><rect width=\"28\" height=\"28\" rx=\"10\" /><rect width=\"28\" height=\"28\" rx=\"10\" /><path stroke-width=\"1.5\" d=\"M15.924 14.818A4.518 4.518 0 0 0 7 15.806a4.516 4.516 0 0 0 8.252 2.538\" /><path stroke-width=\"1.5\" d=\"M12.086 13.216a4.505 4.505 0 0 0 1.013 1.965 4.516 4.516 0 1 0 0-5.974\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol